//css
require('./css/basic.css');
require('./css/footer.css');
require('./css/header.css');
require('./css/normalize.css');
require('./css/style-bundle.css');
require('./css/listing.css');
require('./css/creating.css');
require('./js/plugins/cropper/cropper.min.css');
require('./js/plugins/dropzone/dropzone.min.css');
require('./js/plugins/dragula/dragula.min.css');
require('./js/plugins/datepicker/datepicker.min.css');
require('./js/plugins/select2/select2.min.css')
require('./css/profile.css');
require('./css/agents.css');
require('./css/analytics.css');
require('./css/networks.css');
require('./css/message.css');
require('./css/messages.css');
require('./css/reports.css');
require('./css/temp.css');
require('./css/payments.css');
require('./css/channels.css');

const $ = require('./js/plugins/jquery.min');
global.$ = global.jQuery = $;
require('./js/plugins/jquery.validate.min');
require('./js/plugins/jquery.inputmask.min.js');
const cropper = require('./js/plugins/cropper/cropper.min.js');
global.Cropper = cropper;

require('./js/plugins/dropzone/dropzone.min.js');
const luxon = require('luxon');
global.luxon = luxon;
global.io = require('./js/plugins/socket.io.min.js');
const dragula = require('./js/plugins/dragula/dragula.min.js');
global.dragula = dragula;


require('./js/plugins/charts/chart.min.js');
require('./js/src/modules');
require('./js/src/short_text');
require('./js/src/burger');
require('./js/src/preloader');
require('./js/src/ajax');
require('./js/src/select');
require('./js/src/checkbox');
require('./js/src/accordion');
require('./js/src/cropper');
require('./js/src/mask');
require('./js/plugins/datepicker/datepicker.min.js');
require('./js/src/validation');
require('./js/src/creating_form');
require('./js/src/dropzone');
require('./js/src/radio');
require('./js/src/modal');
require('./js/src/letter_counter');
require('./js/src/tabs');
require('./js/src/popups');
require('./js/src/validation_forms');
require('./js/src/news_post');
require('./js/src/favorites');
require('./js/src/main');
require('./js/src/search');
require('./js/src/maps/creating');
require('./js/src/maps/search');
require('./js/src/load_maps');
require('./js/plugins/select2/select2.min.js');
require('./js/src/select_agent');
require('./js/src/select_listing');
require('./js/src/analytics');
require('./js/src/repeater');
require('./js/src/messenger');
require('./js/src/socket');
require('./js/src/no_reload_links');
require('./js/src/notifications');
require('./js/src/shares');
require('./js/src/listings_type_btn');
require('./js/src/order_details');
require('./js/src/footer_details');
require('./js/src/range');
require('./js/src/order_price');
require('./js/src/ajax_popups');
require('./js/src/download_pdf');
require('./js/src/captcha');
require('./js/src/date_picker');
require('./js/src/select_banner');
require('./js/src/show_profile');

jQuery(function () {
  global.modules.init();
  $('#profile_menu').accordion(function (elem) {
    $(elem).on('click', function () {
      $(this).find('.arrow-list').toggleClass('active')
      elem.parent().siblings().find('.arrow-list').removeClass('active');
    })
  });

  $('.additional_info_accordion').accordion_elem(function (elem) {
    $(elem).on('click', function () {
      $(this).toggleClass('active')
    })
  });

  if ($('#profile_menu').length) {
    $.ajax({
      method: 'POST',
      url: '/profile/menu/info',
      elem: null,
      success: function (response) {
        if (response?.counters) {
          const menu = $('#profile_menu')
          response?.counters.map(el => {
            const node = menu.find(`.${el?.selector}`)
            node
              .children()
              .first()
              .find('.notification')
              .text(el?.count || '')
            if (el.children) {
              const childenList = node.children().eq(1);
              el.children.map(child => {
                childenList
                  .find(`.${child?.selector}`)
                  .find('.notification')
                  .text(child?.count || '')
              })
            }
          })
        }
      }
    })
  }
})